// extracted by mini-css-extract-plugin
module.exports = {"variants":"idt-selectedvariantforoptionsgroup_variants__313rg"};